import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadersModule } from '@shared/core/components/loaders';
import { HeadersModule } from '@shared/core/components/headers';
import { BoxModule } from '@shared/core/components/box';
import { CountersModule } from '@shared/core/components/counters';

import { TileForLoyaltyProgramProductComponent } from './tile-for-loyalty-program-product.shared.component';

@NgModule({
    declarations: [
        TileForLoyaltyProgramProductComponent
    ],
    imports: [
        CommonModule,
        LoadersModule,
        HeadersModule,
        BoxModule,
        CountersModule,
    ],
    exports: [
        TileForLoyaltyProgramProductComponent
    ],
    providers: [],
})
export class TileForLoyaltyProgramProductModule { }
